// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"51":"bb79961a","777":"4b9669b4"}[chunkId] + ".chunk.js";
};